import {Component, input} from '@angular/core';
import {JobStatus} from "../../../../generated-model/model";

@Component({
  selector: 'app-point-job-status',
  standalone: true,
  imports: [],
  templateUrl: './point-job-status.component.html',
  styleUrl: './point-job-status.component.scss'
})
export class PointJobStatusComponent {
  JobStatus = JobStatus;
  status = input.required<JobStatus>();
  type = input<'dry' | 'normal'>('normal');
}
